import { render, staticRenderFns } from "./todo-tmp-old.vue?vue&type=template&id=48c08f67&scoped=true"
import script from "./todo-tmp-old.vue?vue&type=script&lang=js"
export * from "./todo-tmp-old.vue?vue&type=script&lang=js"
import style0 from "./todo-tmp-old.vue?vue&type=style&index=0&id=48c08f67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c08f67",
  null
  
)

export default component.exports